import React from "react";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const addEmployee = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CreateOrModifyEmployee,
    input,
  );
  return data;
};

export const useCreateOrModifyEmployeeMutation = () => {
  return useMutation({
    mutationFn: addEmployee,
  });
};

const checkUserName = async (input) => {
  const data = await http_payroll.post(Api_EndPoints.UserNameValidation, input);
  return data;
};

export const useEmpUserNameValidationMutation = () => {
  return useMutation({
    mutationFn: checkUserName,
  });
};
